import { useEffect } from 'react'
import hideCookieBotWidget, { COOKIEBOT_WIDGET_ID } from '@utils/dom/hideCookieBotWidget'

const RETRY_MS = 250

// Wspólna dla App i Pages Routera (CookieBotRemover.tsx, _app.js) — jedyna
// różnica między nimi to skąd biorą `pathname`. Ponawia co 250ms, bo widget
// dokłada się do DOM asynchronicznie i przy pierwszym renderze może go
// jeszcze nie być.
function useHideCookieBotWidget (pathname, htmlId = COOKIEBOT_WIDGET_ID) {
    useEffect(() => {
        // Bez tego wczesnego wyjścia pętla ponawiania kręciłaby się w
        // nieskończoność na stronie głównej — hideCookieBotWidget zwraca
        // tam zawsze false, tak samo jak wtedy, gdy elementu jeszcze nie ma.
        if (pathname === '/') return

        let timeoutId

        const attempt = () => {
            if (!hideCookieBotWidget(pathname, htmlId)) {
                timeoutId = setTimeout(attempt, RETRY_MS)
            }
        }

        attempt()

        return () => clearTimeout(timeoutId)
    }, [pathname, htmlId])
}

export default useHideCookieBotWidget
